import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { Form, Text, Checkbox } from 'react-form';
import { api, confirm, alerts } from '@src/services/api';
import { isReadOnly, isThisUser, customer } from 'services/user';
import { _ } from "@src/services/i18n";
import { Switch } from "@src/services/form";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { FixUrl, ProtoList, PropsList, StateList } from '@src/components/Proto';
import { SettingsDealer as Edit, Box } from '@src/components';

// typing
interface LocalProps extends PropsList {
    
}
interface LocalState extends StateList {
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Dealer extends ProtoList<LocalProps, LocalState> {
    
    switchFields = {
        id: "dealerid",
        status: "active"
    }

    DeleteBtn = () => {
        return row => {
            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <button
                        className="btn btn-success"
                        onClick={(e) => {
                            this.deleteItem(row);
                        } }
                    >
                        {_('col_customer_delete', 'SettingsDealer')}
                    </button>
                </div>
            );
        }
    };
    async deleteItem( row ) {
        try {
            await confirm(_('col_customer_delete_confirm', 'SettingsDealer'));
        } catch(e) {
            return;
        }
        const { urlDelete = "" } = this.props;
        const url = urlDelete;
        const method = "DELETE";
        try {
            const res = await api({
                url: FixUrl(url, row.original.dealerid),
                method
            });
            if(res.status===202){
                alerts(_('col_user_failed_delete', 'SettingsDealer'));
            }else
            this.reload();
        } catch(e) {
        }
    }
	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { cpt, urlShow, urlCreate, urlUpdate } = this.props;
        const { loading, action, editing, data, search = {}, items = [], tableProps, editProps } = this.state;
        
        const columns = [
            { ...defaultProps.columns.id, accessor: 'dealerid' },
            { Header: _('col_brand', 'SettingsDealer'), accessor: 'brand' },
            { Header: _('col_code', 'SettingsDealer'), accessor: 'code' },
            { Header: _('col_description', 'SettingsDealer'), accessor: 'description' },
            { Header: _('col_date', 'SettingsDealer'), id: 'date', accessor: v => formatters.date(v) },
            {Header: '',
            accessor: 'delete',
            maxWidth: 100,
            Cell: !isReadOnly()?this.DeleteBtn():null,
            sortable: false,}
            // { ...this.SwitchColumn }
        ];
        
        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
            }
        }
        localTableProps.loading = loading;
        
        let localEditProps = {
            ...editProps
        } as any;
        if (action === "EDIT" &&!isReadOnly()) {
            localEditProps.id = editing;
        }

		return (
            <>
            {(action === "CREATE" || action === "EDIT") && !isReadOnly() &&
            <Edit {...localEditProps} />
            }
            <Box
                title={_('list_title', 'SettingsDealer')}
                toolbar={!isReadOnly()?this.Toolbar:null}
                collapsed={false}
            >
                <div className={style}>
                    <Form onSubmit={(v) => this.search(v)}>
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="description">{_('field_description', 'SettingsDealer')}</label>
                                    <Text field="description" id="description" className="form-control" />
                                </article>
                            </div>
                            <footer>
                                <span />
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_search`, 'Settings')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Box>
            
            <ReactTable
                {...localTableProps}
                data={items}
                columns={columns}
            />

            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/List/Dealer.tsx